/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Indemnification_IntroInputs */

const es_tyc_indemnification_intro = /** @type {(inputs: Tyc_Indemnification_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usted acepta indemnizar, defender y mantener indemne a Nexata, sus funcionarios, directores y agentes de y contra cualquier reclamacion, perdida, responsabilidad o dano que surjan de:`)
};

const en_tyc_indemnification_intro = /** @type {(inputs: Tyc_Indemnification_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You agree to indemnify, defend, and hold harmless Nexata, its officers, directors, and agents from and against any claims, losses, liabilities, or damages arising from:`)
};

/**
* | output |
* | --- |
* | "You agree to indemnify, defend, and hold harmless Nexata, its officers, directors, and agents from and against any claims, losses, liabilities, or damages ar..." |
*
* @param {Tyc_Indemnification_IntroInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_indemnification_intro = /** @type {((inputs?: Tyc_Indemnification_IntroInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Indemnification_IntroInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_indemnification_intro(inputs)
	return en_tyc_indemnification_intro(inputs)
});
export { tyc_indemnification_intro as "tyc.indemnification.intro" }